import React, { memo, useContext, useEffect, useMemo, useRef } from 'react';
import { RouteComponentProps } from 'react-router';
import styles from './CustomerServiceDashboard.module.scss';
import classNames from 'classnames/bind';
import { AccountList } from '../../components/AccountList';
import { CustomerServiceDashboardContext } from '../../context';
import { ContractPanel } from '../../components';
import { MonitoringLogModal } from '../../components/MonitoringLogModal';
import { ModalHandle, Title } from 'Mri.Web.Common';

const classes = classNames.bind(styles);
export interface DateRange {
    name: string;
    startDate: Date;
    endDate: Date;
    format: string;
    groupByMonth: boolean;
}

export interface CustomerServiceDashboardProps extends RouteComponentProps<undefined> {}

export const CustomerServiceDashboard = (props: CustomerServiceDashboardProps) => {
    const { state, dispatch } = useContext(CustomerServiceDashboardContext);
    const { selectedContract } = state;
    const EventLogModalHandle = useMemo(() => new ModalHandle(), []);

    // const MemoizedAccountList = useMemo(() => AccountList, [state.accounts, state.accountsVisibleToUser]);
    const MemoizedContractPanel = memo(ContractPanel);
    const MemoizedEventLogModal = memo(MonitoringLogModal);
    useEffect(() => {
        // console.log('CustomerServiceDashboard useEffect');
        // console.log(props);
    }, []);
    return (
        <div>
            <Title>Customer Service Dashboard</Title>
            <div className={classes('dashboard-container')}>
                <div className={classes('accounts', 'card')}>
                    {/*<MemoizedAccountList />*/}
                    <AccountList />
                </div>
                <div className={classes('contract')}>
                    <ContractPanel modalHandle={EventLogModalHandle} />
                </div>
                <MemoizedEventLogModal modalHandle={EventLogModalHandle} />
            </div>
        </div>
    );
};

export default CustomerServiceDashboard;
